module.exports = __webpack_public_path__ + "static/SCAQMD-af03383535b29f89487f7c5148043052.png";